import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import ContactSection from '../../components/ContactSection';
import Header3 from '../../components/header3/Header3';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import ContactHero from '../../components/hero3/contecthero';
import icon1 from '../../images/icons/icon_map_mark_2.svg'
import icon2 from '../../images/icons/icon_calling_2.svg'
import icon3 from '../../images/icons/icon_mail_3.svg'
import contact1 from '../../images/contact1.png'
import email1 from '../../images/email1.png'
import location1 from '../../images/location1.png'


const ContactPage = (props) => {

    return (
        <Fragment>

            <div className='index_business_consulting seo_type'>
                <main className="page_content about-page">
                    <Header3/>
                    <ContactHero top_title={<>Connect With the AI <br/> SEO Experts</>} top_desp={<>With 10+ years in SEO and proven results for 150+ <br/> companies, we’ll help you capture more traffic, leads, <br/> and revenue.</>} />
                    <ContactSection />
                    <CtaSection />

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">

                            <div className="contact_info_box row">
                                <div className="col-lg-4 col-md-6 col-sm-6">
                                    <div className="iconbox_block text-center" style={{backgroundColor: '#F5FFED'}}>
                                        <img src={location1} alt="Mail SVG Icon" />
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title">Location</h3>
                                            <p className="mb-0">
                                               India
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6">
                                    <div className="iconbox_block text-center" style={{backgroundColor: '#FFFCE7'}}>
                                        <img src={contact1} alt="Mail SVG Icon" />
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title">Contact</h3>
                                            <p className="mb-0">+88(0) 555-0108</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6">
                                    <div className="iconbox_block text-center" style={{backgroundColor: '#FFF3F7'}}>
                                        <img src={email1} alt="Mail SVG Icon" />
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title">Your Email</h3>
                                            <p className="mb-0">Techco@example.com</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                        <div style={{ width: '100%', height: '450px', marginTop: '-72px'}}>
                                            <iframe
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7142.007388782767!2d80.2786903939004!3d26.487825907611665!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399c381844aeaa7d%3A0x9f712957889109ea!2sSharda%20Nagar%2C%20Kanpur%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1762364097115!5m2!1sen!2sin"
                                                width="100%"
                                                height="450"
                                                style={{ border: 0 }}
                                                allowFullScreen=""
                                                loading="lazy"
                                                referrerPolicy="no-referrer-when-downgrade"
                                                title="Google Map"
                                            />
                                        </div>
                                </div>
                                
                            </div>
                        </div>
                    </section>
                    <BusinessFooter/>
                </main>
            </div>
            
        </Fragment>
    )
};

export default ContactPage;